import { isNullOrEmpty, isString } from './Is'
import { logParseJson } from './Log'

export const getObj = (stringJson: any, df = {}) => {
  if (isString(stringJson)) {
    try {
      return JSON.parse(stringJson)
    } catch (error) {
      logParseJson(stringJson, error)
    }
  }
  return df
}

export const getString = (obj: object, df = '') => {
  if (!isNullOrEmpty(obj)) {
    try {
      return JSON.stringify(obj)
    } catch (error) {
      logParseJson('[getString]', obj, error)
    }
  }
  return df
}

export const json2Obj = getObj
export const obj2Json = getString
